import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-supplier-transaction-page',
    templateUrl: './supplier-transaction-page.component.html',
    styleUrl: './supplier-transaction-page.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SupplierTransactionPageComponent {

}
